<template>
    <div class="faq-sec bg-white position-relative">
        <div class="container">
            <h2 class="lh-1 fs54 fw-bold titleColor mb-3 mb-lg-4 text-center" data-aos="fade-up" data-aos-duration="500" data-aos-delay="300">
                {{$t("demo_account.sub_heading2_frequently_asked")}} <span class="textPrimary">{{$t("demo_account.sub_heading2_questions")}}</span>
            </h2>
            <p class="fs22 mb-4 mb-md-4 pb-3 fw-medium text-center" data-aos="fade-up" data-aos-duration="500" data-aos-delay="500">{{$t("demo_account.sub_heading2_description")}}</p>
            <div class="d-flex justify-content-end mb-3">
                <a class="textPrimary fw-semiBold pe-4 text-decoration-none" href="https://fxview.com/global/faq" target="_blank">{{$t("demo_account.sub_heading2_more_info")}}</a>
            </div>
            <div class="content-sec">
                <div class="row">
                    <div class="col-xl-6">
                        <div class="accordion" id="accordionExampleLeft" data-aos="fade-up" data-aos-duration="500" data-aos-delay="700">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingOne">
                                    <button class="accordion-button fw-semiBold fs17 shadow-none d-flex align-items-center justify-content-between" type="button" :class="{'active': tab == 1 }" @click="changeTab(1)">
                                        {{$t("demo_account.sub_heading2_faq1_question")}}
                                        <img class="arrowicn ms-3" src="/static/fxView/images/lp/arrow.svg" />
                                    </button>
                                </h2>
                                <div id="collapseOne" class="accordion-collapse collapse" :class="{'show': tab == 1}">
                                    <div class="accordion-body">
                                        <p class="m-0">{{$t("demo_account.sub_heading2_faq1_answer")}}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingTwo">
                                    <button class="accordion-button fw-semiBold fs17 shadow-none d-flex align-items-center justify-content-between" type="button" :class="{'active': tab == 2 }" @click="changeTab(2)">
                                        {{$t("demo_account.sub_heading2_faq2_question")}}
                                        <img class="arrowicn ms-3" src="/static/fxView/images/lp/arrow.svg" />
                                    </button>
                                </h2>
                                <div id="collapseTwo" class="accordion-collapse collapse" :class="{'show': tab == 2}">
                                    <div class="accordion-body">
                                        <p class="mb-0">{{$t("demo_account.sub_heading2_faq2_answer")}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingThree">
                                    <button class="accordion-button fw-semiBold fs17 shadow-none d-flex align-items-center justify-content-between" type="button" :class="{'active': tab == 3 }" @click="changeTab(3)">
                                        {{$t("demo_account.sub_heading2_faq3_question")}}
                                        <img class="arrowicn ms-3" src="/static/fxView/images/lp/arrow.svg" />
                                    </button>
                                </h2>
                                <div id="collapseThree" class="accordion-collapse collapse" :class="{'show': tab == 3}">
                                    <div class="accordion-body">
                                        <p class="mb-0">{{$t("demo_account.sub_heading2_faq3_answer")}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6" data-aos="fade-up" data-aos-duration="500" data-aos-delay="700">
                        <div class="accordion" id="accordionExampleRight">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingFour">
                                    <button class="accordion-button fw-semiBold fs17 shadow-none d-flex align-items-center justify-content-between" type="button" :class="{'active': tab == 4 }" @click="changeTab(4)">
                                        {{$t("demo_account.sub_heading2_faq4_question")}}
                                        <img class="arrowicn ms-3" src="/static/fxView/images/lp/arrow.svg" />
                                    </button>
                                </h2>
                                <div id="collapseFour" class="accordion-collapse collapse" :class="{'show': tab == 4}">
                                    <div class="accordion-body">
                                        <p class="m-0">{{$t("demo_account.sub_heading2_faq4_answer")}}</p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="accordion-item">
                                <h2 class="accordion-header" id="headingFive">
                                    <button class="accordion-button fw-semiBold fs17 shadow-none d-flex align-items-center justify-content-between" type="button" :class="{'active': tab == 5 }" @click="changeTab(5)">
                                        {{$t("demo_account.sub_heading2_faq5_question")}}
                                        <img class="arrowicn ms-3" src="/static/fxView/images/lp/arrow.svg" />
                                    </button>
                                </h2>
                                <div id="collapseFive" class="accordion-collapse collapse" :class="{'show': tab == 5}">
                                    <div class="accordion-body">
                                        <p class="mb-0">{{$t("demo_account.sub_heading2_faq5_answer")}}</p>
                                    </div>
                                </div>
                            </div> -->
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingSix">
                                    <button class="accordion-button fw-semiBold fs17 shadow-none d-flex align-items-center justify-content-between" type="button" :class="{'active': tab == 6 }" @click="changeTab(6)">
                                        {{$t("demo_account.sub_heading2_faq6_question")}}
                                        <img class="arrowicn ms-3" src="/static/fxView/images/lp/arrow.svg" />
                                    </button>
                                </h2>
                                <div id="collapseSix" class="accordion-collapse collapse" :class="{'show': tab == 6}">
                                    <div class="accordion-body">
                                        <p class="mb-0">{{$t("demo_account.sub_heading2_faq6_answer")}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingSeven">
                                    <button class="accordion-button fw-semiBold fs17 shadow-none d-flex align-items-center justify-content-between" type="button" :class="{'active': tab == 7 }" @click="changeTab(7)">
                                        {{$t("demo_account.sub_heading2_faq7_question")}}
                                        <img class="arrowicn ms-3" src="/static/fxView/images/lp/arrow.svg" />
                                    </button>
                                </h2>
                                <div id="collapseSeven" class="accordion-collapse collapse" :class="{'show': tab == 7}">
                                    <div class="accordion-body">
                                        <p class="mb-0">{{$t("demo_account.sub_heading2_faq7_answer")}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    // import { mainStore } from '@/store'
    export default {
        // setup() {
        //   return { store: mainStore() }
        // },
        name: "sectionThird",
        data(){
            return{
                tab : 1
            }
        },
        methods:{
            changeTab(v){
                if(this.tab == v){
                    this.tab = 0;
                }else{
                    this.tab = v
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/fxView/lp/pageSections/section-2.vue